import { Divider, Menu, MenuItem } from '@mui/material';
import React from 'react'
import './menu.scss';

function CustomMenu({ 
  anchorEl = null, 
  open = false, 
  handleClose = () => {}, 
  menuItems = [], // Array of menu items
  className = '',
  transformOrigin = { vertical: "top", horizontal: "right" }, 
  anchorOrigin = { horizontal: "right", vertical: "bottom" },
  handleItemClick = () => {},
  children,
  isApplyCustomMenuCss = true,
  ...props
}) {
  return (
    <Menu
      id="account-menu"
      anchorEl={anchorEl}
      open={open}
      onClose={handleClose}
      onClick={handleClose}
      className={`assign-board-owner-list ${isApplyCustomMenuCss ? 'custom-menu' : ''} ${className}`}
      transformOrigin={transformOrigin}
      anchorOrigin={anchorOrigin}
      {...props}
    >
      {children}
    </Menu>
  );
}

export default CustomMenu;